export const INITIAL_VALUES = {
  name: '',
  category: null,
  package: null,
  active: true,
};
